import { render, staticRenderFns } from "./KelasOnlineEdit.vue?vue&type=template&id=555f9654&scoped=true"
import script from "./KelasOnlineEdit.vue?vue&type=script&lang=js"
export * from "./KelasOnlineEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555f9654",
  null
  
)

export default component.exports